import { useState } from "react";
import { toast } from "react-toastify";
import fileCore from "../../core/file.core";
import DocumentArrowDownloadIcon from "../../icons/documentArrowDownload.icon";
import { DeliverySchedule } from "../../types/delivery";
import { useTranslation } from "../../core/translation.core";
import { getBlob } from "../../core/fetch.core";

export default function DeliveryOrderDownload({ item }: { item: DeliverySchedule }) {
  const { t, msg } = useTranslation();
  // const { data: order } = useOrder();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadPdf = async () => {
    console.log("item", item);

    try {
      setIsDownloading(true);
      const blob = await getBlob("/admin/delivery/downloadDeliveryNote?id=" + item.id);

      fileCore.downloadPdf(blob, "deliveryNote-" + item.id + ".pdf");
    } catch (error) {
      console.error("Failed to download PDF:", error);
      toast.error(t(msg.delivery.deliveryOrderDownloadError));
    } finally {
      setIsDownloading(false);
    }
    // if (!order || !order.retailShop?.id) {
    //   console.error("Order or retail shop not found");
    //   return;
    // }
    // setIsDownloading(true);
    // try {
    //   const blob = await orderCore.downloadOrderInvoicePdf(order.id, order.retailShop.id);
    //   const filename = `invoice-${order.orderNumber}.pdf`;
    //   // Use the file core to download the PDF
    //   fileCore.downloadPdf(blob, filename);
    // } catch (error) {
    //   console.error("Failed to download PDF:", error);
    //   // You might want to show a toast notification here
    // } finally {
    //   setIsDownloading(false);
    // }
  };

  return (
    <button
      onClick={handleDownloadPdf}
      disabled={isDownloading}
      type="button"
      className="flex items-center gap-2 justify-center w-full bg-her-mysticMaroon text-white py-1 rounded-lg"
    >
      <DocumentArrowDownloadIcon className="w-6 h-6 " />
      {t(msg.delivery.deliveryOrder)}
    </button>
  );
}
